import script from "./VideoUploaderButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoUploaderButton.vue?vue&type=script&lang=ts&setup=true"

import "./VideoUploaderButton.vue?vue&type=style&index=0&id=14b17340&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14b17340"]])

export default __exports__